import React from 'react';
import styles from './index.module.css';
import { AD_TYPES } from "../../utils";
import BookDemo from "../BookDemo";

type Props = {
  title?: string;
  description?: string;
  contentType?: 'SA' | 'NG' | 'TN';
  adTypes?: Array<{
    id: number;
    title: string;
    description: string;
    image: string;
    imageWebp?: string;
    imageAvif?: string;
    alt: string;
    mobImage?: string;
    mobImageWebp?: string;
    mobImageAvif?: string;
    size: number;
    mobSize: number;
  }>;
  adTypesClassName?: string;
  bookDemoProps?: {
    redirectLink?: string;
    classes?: {
      bookDemo?: string;
      button?: string;
    }
  }
}

const AdTypes = ({
  adTypes = AD_TYPES,
  title,
  description,
  contentType,
  adTypesClassName = '',
  bookDemoProps = {},
  }: Props) => {
  return (
    <section className={`${styles.typesOfAds} ${adTypesClassName}`}>
      <>
        <h1 className={styles.headline}>Multiple ad formats to help you stand out</h1>
        <p className={styles.description}>Provide your target audience with the most attractive ads</p>
      </>

      <div className={styles.adBox}>
        {adTypes?.map(ad => (
          <div key={ad.id} className={styles.adType}>
                <picture>
                  {ad.imageAvif && (
                    <source
                      srcSet={ad.imageAvif}
                      media='(min-width: 520px)'
                      type='image/avif'
                      //@ts-ignore
                      width={ad.size}
                    />
                  )}
                  <source
                    srcSet={ad.imageWebp}
                    media='(min-width: 520px)'
                    type='image/webp'
                    //@ts-ignore
                    width={ad.size}
                  />
                  {ad.mobImageAvif && (
                    <source
                      srcSet={ad.mobImageAvif}
                      media='(max-width: 520px)'
                      type='image/avif'
                      //@ts-ignore
                      width={ad.mobSize}
                    />
                  )}
                  <source
                    srcSet={ad.mobImageWebp}
                    media='(max-width: 520px)'
                    type='image/webp'
                    //@ts-ignore
                    width={ad.mobSize}
                  />
                  <source
                    srcSet={ad.image}
                    media='(min-width: 520px)'
                    type='image/png'
                    //@ts-ignore
                    width={ad.size}
                  />
                  <source
                    srcSet={ad.mobImage}
                    media='(max-width: 520px)'
                    type='image/png'
                    //@ts-ignore
                    width={ad.mobSize}
                  />
                  <img
                    src={ad.image}
                    alt={ad.alt}
                    width={ad.size}
                    height='100%'
                  />
                </picture>
                <div className={styles.contentWrapper}>
                  <h4 className={styles.adTitle}>{ad.title}</h4>
                  <p className={styles.adDescription}>{ad.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.bookDemo}>
            <BookDemo {...bookDemoProps} />
          </div>

    </section>
  )
}

export default AdTypes;